export default __webpack_public_path__ + "static/gift-card-1.url-4dbbab896d7e59717956f1cefded10bc.svg";